<template>
  <div class="counter-container" :style="containerStyle">
    <div class="counter-value" :style="valueStyle">{{ value }}</div>
    <el-divider class="divider"></el-divider>
    <div class="counter-label-container">
      <span class="counter-label">{{ $t(labelI18nKey) }}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    width: {
      type: String,
      default: '31.3%'
    },
    labelI18nKey: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    valueColor: {
      type: String,
      default: '#606060'
    }
  },
  data () {
    return {
      showLabel: true
    }
  },
  computed: {
    containerStyle () {
      return {
        width: this.width
      }
    },
    valueStyle () {
      return {
        color: this.valueColor
      }
    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.counter-container {
  display: flex;
  padding: 10px 0;
  border-radius: 3px;
  align-items: center;
  flex-direction: column;
  color: #606060;
  font-size: 14px;
  background: #f7f7f7;
  position: relative;

  &:not(:first-child) {
    margin-left: 2%;
  }

  &.right-arrow {
    padding-right: 20px;
  }

  .counter-value {
    font-size: 18px;
    font-weight: bold;
  }

  .divider {
    width: 30%;
    margin: 10px auto;
    background-color: #232323;
  }

  .counter-label-container {
    flex: 1;
    font-size: 12px;
    padding: 0 5px;
    width: 100%;
    text-align: center;

    .date {
      display: flex;

      .date-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .date {
          line-height: 1;
        }

        .number {
          font-size: 16px;
        }
      }
    }
  }

  .right-arrow {
    display: flex;
    height: 100%;
    padding-left: 5px;
    padding-right: 2px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;

    &:hover {
      background: #eeeeee;
    }

    .arrow-icon {
      font-size: 16px;
    }
  }
}
</style>
